import ShoppingListContainer from "@/components/ShoppingList/ShoppingListContainer";
import CategoryPage from "@/src/categories/components/CategoryPage";
import getCategoryStaticProps from "@/src/categories/lib/getCategoryStaticProps";
import type CategoryGroup from "@/src/categories/types/CategoryGroup";
import createBreadcrumbsJsonLd from "@/src/recipes/lib/createBreadcrumbsJsonLd";
import Head from "next/head";
import { Seomatic } from "react-seomatic";

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export async function getStaticProps({ params }) {
  const group = params.group as CategoryGroup;
  const categorySlug = params.slug;

  const categoryPageProps = await getCategoryStaticProps({
    group,
    slug: categorySlug,
  });

  const category = categoryPageProps.props.category;
  const recipes = categoryPageProps.props.recipes;

  const breadcrumbs = [
    {
      label: group.charAt(0).toUpperCase() + group.slice(1),
      href: `/${group}`,
    },
  ];

  if (categorySlug && category) {
    breadcrumbs.push({ label: category.title, href: null });
  }

  const jsonLdSchema = [createBreadcrumbsJsonLd(breadcrumbs)];

  return {
    props: {
      ...categoryPageProps.props,
      recipes,
      breadcrumbs,
      category,
      jsonLdSchema,
    },
  };
}

const CategoryPagePage = ({
  pageEntry,
  category,
  recipes,
  pageCount,
  pageNumber,
  breadcrumbs,
}) => {
  return (
    <>
      <Seomatic Head={Head} {...category.seomatic} />
      <ShoppingListContainer />

      <CategoryPage
        pageEntry={pageEntry}
        category={category}
        recipes={recipes}
        pageCount={pageCount}
        pageNumber={pageNumber}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

export default CategoryPagePage;
